import React, { useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { ButtonSecondary, screenXsMax, spacer16, LoadingIndicator, Type } from '@spotify-internal/encore-web';

import { useVerticalConfig } from 'providers/vertical';
import { useCustomer } from 'utils/user';
import { UbiArticlePage } from 'utils/ubi/pages/useUbiArticle';

import StyledCard from '../StyledCard';

const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;

  @media (max-width: ${screenXsMax}) {
    grid-template-columns: 1fr;
    gap: ${spacer16};
  }
`;

const StyledButtonContainer = styled.div`
  text-align: right;
  align-self: center;
`;

export const CTA_BTN_TEST_ID = 'account-page-cta-btn';

const AccountPageCta = ({ ubi }: { ubi: UbiArticlePage }) => {
  const { verticalName } = useVerticalConfig();
  const { isFetching, user } = useCustomer();
  const ctaText = user ? 'Go to your Account' : 'Log in to your Account';

  useEffect(() => {
    ubi.logAccountPageCtaImpression();
  }, [ubi]);

  const handleCtaBtnClick = useCallback(
    e => {
      ubi.logAccountPageCtaHit(e.target.href);
    },
    [ubi],
  );

  return (
    <StyledCard vertical={verticalName}>
      <StyledGrid>
        <div>
          <Type as="h5" variant="balladBold" paddingBottom=".8em">
            Manage your Spotify Account easily
          </Type>
          <Type as="p" variant="ballad">
            Your info, payment and privacy all in one place.
          </Type>
        </div>
        <StyledButtonContainer>
          <ButtonSecondary
            href="https://www.spotify.com/account/"
            size="small"
            onClick={handleCtaBtnClick}
            data-testid={CTA_BTN_TEST_ID}
          >
            {isFetching ? <LoadingIndicator /> : ctaText}
          </ButtonSecondary>
        </StyledButtonContainer>
      </StyledGrid>
    </StyledCard>
  );
};

export default AccountPageCta;
